import React from 'react'

import TideStationName from '../TideStationName'
import TideSummary from './TideSummary'
import TideGraph from './TideGraph'
import TideGraphLegend from './TideGraphLegend'
import EventTable from './EventTable'
import LoadingSpinner from '../LoadingSpinner'
import loadingAnimation from '../../assets/images/loading.svg'


import styles from './DayPage.module.css'




const DayPageView = (props) => {
  const {
    now,
    date,
    events,
    threeDayTides,
    tideHeightRange,
    tidesLoading,
  } = props

  return (
    <div className={styles.DayPage}>
      <div className={styles.column}>

        <div className={styles.betaNote}>
          <div className={styles.innerContainer}>
            MyTides is in beta and should not be used for planning.
          </div>
        </div>

        <div className={styles.TideSummary}>
          <div className={styles.innerContainer}>
            <TideSummary />
          </div>
        </div>

        {tidesLoading &&
          <LoadingSpinner />
        }

        {!tidesLoading &&
          <div className={styles.TideGraph}>
            <div className={styles.innerContainer}>
              <TideGraph
                now={now}
                date={date}
                tides={threeDayTides}
                tideHeightRange={tideHeightRange}
              />
            </div>
          </div>
        }
        {!tidesLoading &&
          <div className={styles.TideGraphLegend}>
            <div className={styles.innerContainer}>
              <TideGraphLegend tideHeightRange={tideHeightRange} />
            </div>
          </div>
        }
        {!tidesLoading &&
          <div className={styles.EventTable}>
            <div className={styles.innerContainer}>
              <EventTable events={events} />
            </div>
          </div>
        }

        <div className={styles.TideStationName}>
          <TideStationName />
        </div>

      </div>
    </div>
  )
}

export default DayPageView



// WEBPACK FOOTER //
// ./src/components/DayPage/DayPageView.js